import { render, staticRenderFns } from "./RadioTypeCheck.vue?vue&type=template&id=2a62487a&scoped=true&"
import script from "./RadioTypeCheck.vue?vue&type=script&lang=js&"
export * from "./RadioTypeCheck.vue?vue&type=script&lang=js&"
import style0 from "./RadioTypeCheck.vue?vue&type=style&index=0&id=2a62487a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a62487a",
  null
  
)

export default component.exports